import Vue from 'vue'
import VueI18n from 'vue-i18n';
import {DEFAULT_LANG} from "@/config";


Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context(
    "@/locales", // Путь к папке с нашими json файлами локализации
    true,
    /[A-Za-z0-9-_,.\s]+\.json$/i
  );
  const messages:any = {};
  locales.keys().forEach(key => {
    const matched = key.slice(2).split('.');
    if (matched && matched.length == 2) {
      const locale = matched[0];

      messages[locale] = Object.assign({},messages[locale],locales(key));
    }

    if (matched && matched.length == 3) {
      const locale = matched[1];

      let ind:string = matched[0], ob:any = {};

      ob[ind] =  locales(key);

      messages[locale] = Object.assign({},messages[locale],ob);


    }


  });
  return messages;
}
let localStorageLocale = localStorage.getItem('locale')
const langs = ['en', 'de', 'ru']
export const selectedLocale = localStorageLocale && langs.includes(localStorageLocale) ? localStorageLocale : DEFAULT_LANG;
export const languages = Object.getOwnPropertyNames(loadLocaleMessages());
export default new VueI18n({
  locale: selectedLocale || DEFAULT_LANG,
  fallbackLocale: DEFAULT_LANG,
  messages: loadLocaleMessages()
});
